import { CommonModule } from '@angular/common';
import { Component,  Input } from '@angular/core';

@Component({
    selector: 'subtitle-wrapper',
    template: `
<h5 *ngIf="!!title">{{ title }}</h5>
<div class="empty" *ngIf="!!emptyText">{{ emptyText }}</div>
<ng-content></ng-content>
`,
    styles: [`
  :host { display: flex; flex-direction: column; }
  h5 { margin-bottom: 3px; }
  .empty { color: rgba(0, 0, 0, 0.4); font-style: italic; }
`],
    standalone: true,
    imports: [CommonModule],
})
export class SubtitleWrapperComponent {
  @Input() title: string = null
  @Input() emptyText: string = null
}

